/* 德语  */
export default {
 "route": {
    "title": "Informationsveröffentlichungssystem",
    "home": "Startseite",
    "terminal": "Terminal",
    "program": "Programm",
    "h5program": "Programm",
    "my": "Mein",
    "remote_control": "Fernbedienung",
    "task_details": "Aufgabendetails",
    "add_task": "Aufgabe hinzufügen",
    "program_list": "Programmliste",
    "terminal_info": "Terminalinformationen",
    "add_resolution": "Auflösung hinzufügen",
    "add_program": "Programm hinzufügen",
    "material_management": "Materialverwaltung",
    "create_program": "Programm erstellen",
    "login": "Anmelden",
    "reset_password": "Passwort zurücksetzen",
    "change_password": "Passwort ändern",
    "preview": "Vorschau"
  },
  append_field:{
      "input_code": "Bitte geben Sie den Bestätigungscode ein",
      "code_error": "Bestätigungscode falsch",
      "fill_code": "Bitte Bestätigungscode eingeben",
      "dOut": "3D-Rotation aus",
      "dIn": "3D-Rotation ein",
      "dxiao": "3D-Rahmen",
      "selectImage": "Bitte wählen Sie ein Bild",
      "onlySelectOneImage": "Es kann nur ein Bild ausgewählt werden",
      "imageFormatError": "Bildformatfehler",
      "cancel": "Abbrechen",
      "selectedNumber": "Ausgewählt",
      "confirm": "Bestätigen",
      "loadinga": "Lädt...",
      "loadingb": "Laden",
      "uploading": "Hochladen",
      "selectStartDates": "Startdatum wählen",
      "selectEndDates": "Enddatum wählen",
      "createTask": "Neue Aufgabe erstellen",
      "selectPrograms": "Programme auswählen",
      "createPrograms": "Neues Programm",
      "editTask": "Aufgabe bearbeiten",
      "fillTaskName": "Bitte Name eingeben",
      "selectTaskGroup": "Bitte Aufgabengruppe wählen",
      "selectProgram": "Bitte Programm wählen",
      "selected": "Ausgewählt",
      "programs": "Programme",
      "selectDevice": "Bitte Gerät wählen",
      "sendTaskSuccess": "Aufgabe erfolgreich gesendet",
      "taskName": "Name",
      "playMode": "Abspielmodus",
      "replaceMode": "Ersetzen-Modus",
      "appendMode": "Anhängen-Modus",
      "apotpatterns": "Einfügen-Modus",
      "dateRange": "Abspieldatum",
      "timeRange": "Abspielzeit",
      "taskPeriod": "Wochentage",
      "mon": "Mo",
      "tue": "Di",
      "wed": "Mi",
      "thu": "Do",
      "fri": "Fr",
      "sat": "Sa",
      "sun": "So",
      "back": "Zurück",
      "programList": "Programmliste",
      "deviceList": "Geräteliste",
      "enterContent": "Bitte Inhalt eingeben",
      "taskGroup": "Aufgabengruppe",
      "selectStartDate": "Bitte Startdatum wählen",
      "selectEndDate": "Bitte Enddatum wählen",
      "selectStartTime": "Bitte Startzeit wählen",
      "selectEndTime": "Bitte Endzeit wählen",
      "addTask": "Aufgabe hinzufügen",
      "topLeft": "Oben links",
      "topCenter": "Oben Mitte",
      "topRight": "Oben rechts",
      "leftCenter": "Links Mitte",
      "center": "Zentriert",
      "rightCenter": "Rechts Mitte",
      "bottomLeft": "Unten links",
      "bottomCenter": "Unten Mitte",
      "bottomRight": "Unten rechts",
      "enterText": "Bitte Text eingeben",
      "fontColor": "Schriftfarbe",
      "bgColor": "Hintergrundfarbe",
      "scrollDirection": "Scrollrichtung",
      "scrollSpeed": "Scrollgeschwindigkeit",
      "fontSize": "Schriftgröße",
      "alignment": "Ausrichtung",
      "subtitle": "Untertitel",
      "enterURL": "Bitte URL eingeben",
      "webPage": "Webseite",
      "enterMediaURL": "Bitte Medien-URL eingeben",
      "media": "Streaming-Medien",
      "selectVideo": "Bitte Video wählen",
      "unsupportedFormat": "Nicht unterstütztes Dateiformat",
      "cancelAllSelections": "Bitte alle ausgewählten Materialien abwählen, bevor neue Dateien hochgeladen werden",
      "fileName": "Dateiname",
      "fileSize": "Dateigröße",
      "uploadProgress": "Upload-Fortschritt",
      "cancelUpload": "Upload abbrechen",
      "cancelAllUploads": "Alle Uploads abbrechen",
      "leftToRights": "Von links nach rechts",
      "rightToLefts": "Von rechts nach links",
      "bottomToTops": "Von unten nach oben",
      "static": "Statisch",
      "slow": "Langsam",
      "medium": "Mittel",
      "fast": "Schnell",
      "colorValue": "Farbwert",
      "defaultEffect": "Standard-Effekt",
      "rightToLeft": "Von Rechts nach Links",
      "leftToRight": "Von Links nach Rechts",
      "topToBottom": "Von Oben nach Unten",
      "bottomToTop": "Von Unten nach Oben",
      "accordionSqueeze": "Akkordeon zusammendrücken",
      "zoomInFade": "Zoom-In",
      "zoomOutFade": "Zoom-Out",
      "depthOfField": "Schärfentiefe verändern",
      "leftRightRotate": "Drehen L/R",
      "upDownRotate": "Drehen O/U",
      "counterclockwiseRotate": "Drehen gegen den Uhrzeigersinn",
      "clockwiseRotate": "Drehen im Uhrzeigersinn",
      "upDownZoom": "Zoom O/U",
      "scaleFade": "Zoom verändern",
      "zoomInDisappearing": "Animation vergrößern/ausblenden",
      "transparentFade": "Transparenz-Verblassen",
      "gradientScale": "Zoom verändern",
      "deleteMaterial": "Material löschen",
      "confirmDeleteMaterial": "Löschen dieses Materials bestätigen?",
      "unreviewed": "Ungeprüft",
      "normal2": "Normal",
      "violating": "Verstoß",
      "suspectedViolating": "Verdächtigter Verstoß",
      "delete": "Löschen",
      "selectMaterial": "Bitte Material wählen",
      "deleteProgramGroup": "Programmgruppe löschen",
      "confirmDeleteGroup": "Löschen dieser Gruppe bestätigen?",
      "add": "Hinzufügen",
      "toggle_effect": "Animationseffekte",
      "toggle_time": "Zeit wechseln",
      "pub_toggle_time": "Zeit für Bildwiedergabe",
      "fullscreen": "Vollbild",
      "normal": "Normal",
      "interactive": "Interaktiv",
      "main_screen": "Hauptbildschirm",
      "sub_screen": "Nebenbildschirm",
      "dual_screen": "Doppelbildschirm",
      "sync_task": "Synchronisierungsaufgabe",
      "normal_mode": "Normalmodus",
      "basic_info": "Grundinformationen",
      "program_info": "Programminformationen",
      "task_name": "Programmname",
      "task_type": "Aufgabentyp",
      "pub_task": "Normale Aufgabe",
      "hu_task": "Interaktive Aufgabe",
      "no_data": "Keine Daten",
      "no_msg": "Keine Nachrichten",
      "program_name": "Programmname",
      "program_resolution": "Programmauflösung",
      "program_type": "Programmtyp",
      "screen_category": "Bildschirmkategorie",
      "edit_program": "Programm bearbeiten",
      "edit": "Bearbeiten",
      "send": "Senden",
      "create": "Gruppe erstellen",
      "reload": "Aktualisieren",
      "name": "Name",
      "create_task_z": "Aufgabengruppe erstellen",
      "ps_push_name": "Bitte Gruppennamen eingeben",
      "device_list": "Geräteliste",
      "delete_task_group": "Aufgabengruppe löschen",
      "confirm_delete_group": "Löschen dieser Gruppe bestätigen?",
      "delete_success": "Erfolgreich gelöscht",
      "name_cannot_be_empty": "Name darf nicht leer sein",
      "character_length_limit": "Zeichenlänge muss innerhalb von 10 Zeichen liegen",
      "create_task_success": "Aufgabe erfolgreich erstellt",
      "create_task_failed": "Erstellung fehlgeschlagen",
      "confirm_delete_task": "Aufgabe wirklich löschen?",
      "task_details": "Aufgabendetails",
      "download_success": "Erfolgreich heruntergeladen",
      "waiting_download": "Warten auf Download",
      "downloading": "Herunterladen",
      "confirm_delete": "Löschen bestätigen?",
      "confirm_delete_all": "Alle löschen bestätigen?",
      "confirm_delete_selected": "Ausgewählte löschen bestätigen?",
      "no_data_to_clear": "Keine Daten zum Löschen!",
      "refresh": "Aktualisieren",
      "clear_all": "Alles löschen",
      "clear_completed": "Löschen",
      "device_id": "Geräte-ID",
      "task_size": "Aufgabengröße",
      "speed": "Geschwindigkeit",
      "download_progress": "Download-Fortschritt",
      "title": "Titel",
      "volume": "Lautstärke",
      "deleteP": "Programm löschen",
      "con_P": "Löschen dieses Programms bestätigen?",
      "clear": "Leeren",
      "download_status": "Download-Status",
      "height_width_cannot_be_empty": "Höhe/Breite darf nicht leer sein",
      "add_success": "Erfolgreich hinzugefügt",
      "enter_number_between_300_to_8000": "Bitte eine Zahl zwischen 300 und 8000 eingeben",
      "width": "Breite",
      "enter_width": "Breite eingeben",
      "height": "Höhe",
      "enter_height": "Höhe eingeben",
      "confirm_leave_page": "Seite wirklich verlassen?",
      "add_content_to_control": "Bitte Inhalt zum Steuerelement hinzufügen",
      "add_control": "Steuerelement hinzufügen",
      "save_success": "Erfolgreich gespeichert",
      "save": "Speichern",
      "create_program": "Programm erstellen",
      "guess": "Du rate mal",
      "modify": "Ändern",
      "text": "Text",
      "image": "Bilder",
      "background_image": "Hintergrundbild",
      "background_music": "Hintergrundmusik",
      "replace": "Ersetzen",
      "use_this_template": "Diese Vorlage verwenden",
      "apply_template": "Vorlage anwenden",
      "enter_program_name": "Programmnamen eingeben",
      "program_group": "Programmgruppe",
      "select_program_group": "Programmgruppe auswählen",
      "group_list": "Gruppen verwalten",
      "preview": "Vorschau",
      "my_apps": "Meine Apps",
      "template_center": "Vorlagenzentrum",
      "home": "Startseite",
      "source_of_visit": "Besuchsquelle",
      "online": "Online",
      "terminal_status": "Status",
      "memory_status": "Speicherstatus",
      "login": "Anmelden",
      "sms_verification": "SMS-Verifizierung",
      "email_verification": "E-Mail-Verifizierung",
      "log_in": "Anmelden",
      "enter_username": "Benutzernamen eingeben",
      "username_cannot_be_empty": "Benutzername darf nicht leer sein",
      "password_cannot_be_empty": "Passwort darf nicht leer sein",
      "incorrect_phone_format_for_verification_code": "Falsches Telefonformat für den Verifizierungscode, bitte Administrator kontaktieren!",
      "incorrect_email_format_for_verification_code": "Falsches E-Mail-Format für den Verifizierungscode, bitte Administrator kontaktieren!",
      "incorrect_phone_or_email_format_for_verification_code": "Falsches Telefon- oder E-Mail-Format für den Verifizierungscode, bitte Administrator kontaktieren!",
      "reset_password": "Passwort zurücksetzen",
      "remember_password": "Passwort merken",
      "register": "Registrieren",
      "current_version_4.1.6": "V4.1.8",
      "notification_about_network_security": "Hinweis zur Netzwerksicherheit",
      "got_it": "Verstanden",
      "please_authenticate_for_account_safety": "Bitte zur Sicherheit Ihres Kontos authentifizieren",
      "enter_account": "Konto eingeben",
      "enter_password": "Passwort eingeben",
      "verification_code": "Verifizierungscode",
      "none": "Keine",
      "personal_center": "Persönliches Zentrum",
      "remote_control": "Fernbedienung",
      "refresh_success": "Erfolgreich aktualisiert!",
      "logout": "Abmelden",
      "confirm_logout": "Abmelden bestätigen?",
      "user_status": "Benutzerstatus",
      "customer_address": "Kundenadresse",
      "account_period": "Kontolaufzeit",
      "device_control": "Gerätesteuerung",
      "clear_cache": "Cache leeren",
      "exit": "Beenden",
      "terminal": "Terminal",
      "program": "Programm",
      "material": "Material",
      "my": "Mein",
      "display_type": "Anzeigetyp",
      "proportion": "Seitenverhältnis",
      "resolution": "Auflösung",
      "screen_orientation": "Bildschirmausrichtung",
      "landscape": "Querformat",
      "portrait": "Hochformat",
      "add_resolution": "Auflösung hinzufügen",
      "execute_formatting_when_focus_lost": "Formatierung bei Fokusverlust ausführen",
      "select_resolution": "Auflösung auswählen",
      "resolution_list": "Auflösungsliste",
      "confirm_delete_program": "Programm wirklich löschen?",
      "confirm_delete_this_program": "Dieses Programm wirklich löschen?",
      "bound_tasks_exists_confirm_delete": "Gebundene Aufgaben vorhanden, wirklich löschen?",
      "prompt": "Hinweis",
      "delete_failed": "Löschen fehlgeschlagen",
      "modification_time": "Änderungszeit",
      "resolution_": "Auflösung",
      "associated_tasks": "Verknüpfte Aufgaben",
      "bound_task": "Gebundene Aufgabe",
      "program_management": "Programmverwaltung",
      "task": "Aufgabe",
      "progress": "Fortschritt",
      "phone_number": "Telefonnummer",
      "enter_phone_number": "Telefonnummer eingeben",
      "password": "Passwort",
      "confirm_password": "Passwort bestätigen",
      "enter_password_again": "Passwort erneut eingeben",
      "company_name": "Firmenname",
      "enter_company_name": "Firmeninformationen eingeben",
      "address": "Adresse",
      "enter_address": "Kontaktadresse eingeben",
      "username_not_exist": "Benutzername existiert nicht",
      "enter_new_password": "Neues Passwort eingeben",
      "enter_new_password_again": "Neues Passwort erneut eingeben",
      "terminal_management": "Terminalverwaltung",
      "delete_group": "Gruppe löschen",
      "pel_select_group": "Gruppe auswählen",
      "enter_device_name": "Gerätenamen eingeben",
      "delete_device": "Gerät löschen",
      "confirm_delete_device": "Löschen dieses Geräts bestätigen?",
      "terminal_information": "Terminalinformationen",
      "qr_code_error": "QR-Code-Fehler",
      "device_not_supported": "Gerät wird nicht unterstützt",
      "device_offline": "Gerät muss online sein, um Befehle zu senden, bitte erneut auswählen!",
      "more": "Mehr",
      "device_access": "Gerätezugang",
      "filter": "Filter",
      "all": "Alle",
      "offline": "Offline",
      "device_name": "Gerätename",
      "device_number": "Gerätenummer",
      "device_group": "Gerätegruppe",
      "call_device_please_wait": "Gerät aufrufen, bitte warten...",
      "create_terminal_group": "Neue Gruppe",
      "enter_search_keyword": "Suchbegriff eingeben",
      "bind_device": "Gerät binden",
      "select_device_group": "Gerätegruppe auswählen",
      "authorized": "Autorisierte",
      "unauthorized": "Nicht autorisierte",
      "adjust_volume": "Lautstärke anpassen",
      "reboot_device": "Gerät erneut starten",
      "wake_up": "Aufwecken",
      "sleep": "In den Ruhezustand versetzen",
      "shutdown": "Abschalten",
      "clean_up_timing_on_off": "Timer löschen",
      "clean_up_disk": "Festplatte bereinigen",
      "clean_up_task": "Aufgabe bereinigen",
      "send_command": "Befehl senden",
      "confirm2": "Senden bestätigen-",
      "terminal_operation": "Terminaloperation",
      "bind_task": "Aufgaben-Info",
      "remote_command": "Fernbefehl",
      "remote_monitor": "Fernüberwachung",
      "adding_one_will_override_the_previous": "Nur ein Zeitplan erlaubt",
      "screenshot_in_progress_please_wait": "Screenshot wird erstellt, bitte warten",
      "schedule_on_off": "Timer Ein/Aus",
      "shutdown_time": "Herunterfahrzeit",
      "startup_time": "Startzeit",
      "volume_setting": "Lautstärkeeinstellung",
      "edit_device_name": "Gerätenamen bearbeiten",
      "please_select_time": "Zeit auswählen",
      "device_not_online_please_retry": "Gerät nicht online, bitte erneut versuchen",
      "sent_successfully": "Erfolgreich gesendet",
      "version": "V4.1.8",
      "texta": "Text",
      "userName": "Benutzername",
      "email": "E-Mail",
      "device_memory": "Gerätespeicher",
      "device": "Gerät",
      "device_mac": "Geräte-MAC",
      "screen_count": "Bildschirmanzahl",
      "device_location": "Gerätestandort",
      "is_authorized": "Ist autorisiert",
      "remark": "Bemerkung",
      "device_ip": "Geräte-IP",
      "system_version": "Systemversion",
      "playback_date": "Wiedergabedatum",
      "playback_period": "Wiedergabezeitraum",
      "retrieve_again": "Erneut abrufen",
      "please_enter_password": "Bitte ein Passwort mit mehr als 8 Zeichen eingeben, das Zahlen, Buchstaben und Sonderzeichen [@#$%^&+=] enthält!",
      "passwords_do_not_match": "Passwörter stimmen nicht überein",
      "enter_new_password2": "Neues Passwort eingeben",
      "current_password_too_simple": "Aktuelles Passwort zu einfach, bitte ändern Sie es zum Schutz Ihres Kontos. Geben Sie ein Passwort mit mehr als 8 Zeichen ein, das Zahlen, Buchstaben und Sonderzeichen [@#$%^&+=] enthält",
      "creation_time": "Erstellungszeit",
      "login2": "Anmelden",
      "welcome": "Willkommen",
      "expired_login": "Authentifizierung abgelaufen, bitte erneut anmelden.",
      "control": "Fernbedienung",
      "add_task": "Aufgabe hinzufügen",
      "program_list": "Programmliste",
      "terminal_info": "Terminalinformationen",
      "add_program": "Programm hinzufügen",
      "material_management": "Materialverwaltung",
      "change_password": "Passwort ändern",
      "enter_text_content": "Textinhalt eingeben",
      "hit_the_wall_on_back": "Dahinter ist nur die Wand",
      "last_ceremony": "Letzte Zeremonie",
      "already_top_level": "Bereits auf höchster Ebene",
      "already_last_one": "Bereits das letzte Mal",
     "white_fox": "Weißer Fuchs",
      "control_img": "Bild",
      "control_video": "Video",
      "control_streaming": "Streaming",
      "control_webPage": "Webseite",
      "control_subtitle": "Text",
      "control_HDMI": "HDMI",
      "control_addbackground": "Hintergrund",
      "Up": "Hochladen",
      "onlyOne": "Es kann nur ein Steuerelement hinzugefügt werden",
      "clearBg": "Hintergrund löschen",
      "get_code": "Bitte zuerst den Code eingeben",
      "del_Null_Program": "Möchten Sie leere Programme aus der Liste löschen?",
      "please_select_date": "Bitte mindestens ein Datum auswählen",
      "last_size": "Verbleibender Speicherplatz",
      "shutdown_tips": "Nach dem Herunterfahren kann das Gerät nicht aus der Ferne eingeschaltet werden",
      "last_size_upload": "Bitte erneut auswählen.",
      "end_date_earlier_than_start_date": "Das Enddatum kann nicht vor dem Startdatum liegen",
      "account_type": "Benutzertyp",
      "user_type": "Normaler Benutzer",
      "role_type": "Rolle",
      "super_administrator": "Superadministrator",
      "term_info_empty": "Terminalinformationen sind leer",
      "select_terminal_prompt": "Bitte klicken Sie auf die Schaltfläche in der oberen rechten Ecke, um ein Terminal auszuwählen",
      "select": "Auswählen",
      "data_empty": "Keine Daten!",
      "content_review": "Inhaltsüberprüfung",
      "start_date": "Startdatum",
      "end_date": "Enddatum",
      "start_time": "Startzeit",
      "end_time": "Endzeit",
      "select_all": "Alle auswählen",
      "select_group": "Gruppe auswählen",
      "review": "Überprüfen",
      "material_type": "Materialtyp",
      "audio": "Audio",
      "document": "Datei",
      "material_status": "Materialstatus",
      "material_review": "Materialüberprüfung",
      "current_selection_requires_review": "Muss das aktuell ausgewählte Material überprüft werden?",
      "invCode": "Einladungscode",
      "tip_invitation_empty": "Bitte Einladungscode eingeben",
      "enter_userName": "Bitte Benutzerkonto eingeben",
      "enter_email": "Bitte E-Mail eingeben",
      "file_less_38": "Datei kleiner als 38kb",
      "viewError": "Diese Datei unterstützt keine Vorschau",
      "user": "Persönliche Informationen",
      "phone_number_too_short": "Telefonnummer muss länger als 9 Zeichen sein",
      "oneImage": "Hintergrundbild bereits vorhanden. Bitte zuerst löschen, um ein neues hochzuladen",
      "del_title": "Löschen bestätigen",
      "del_message": "Möchten Sie das Steuerelement wirklich löschen?",
      "close": "Schließen",
      "exit_group_name": "Gruppe bearbeiten",
      "group_management": "Gruppenverwaltung",
      "language": "Sprachumschaltung",
      "mixture": "Gemischt",
      "date": "Datum",
      "weeks": "Woche",
      "time": "Uhrzeit",
      "new_password": "Neues Passwort",
      "enter_invCode": "Hinweis: Bitte den Einladungscode vom übergeordneten Administrator anfordern",
      "msg_password": "Hinweis: Bitte ein Passwort mit mehr als 8 Zeichen eingeben, das Zahlen, Buchstaben und Sonderzeichen [@#$%^&+=] enthält!",
      "oneDoc": "Dokument bereits vorhanden. Bitte zuerst löschen, um ein neues hochzuladen",
      "Sunday": "Sonntag",
      "Monday": "Montag",
      "Tuesday": "Dienstag",
      "Wednesday": "Mittwoch",
      "Thursday": "Donnerstag",
      "Friday": "Freitag",
      "Saturday": "Samstag",
      "input_error": "Alle Formularfelder dürfen nicht leer sein",
      "video_tutorial": "Material",
      "view": "Online ansehen",
      "selectDeviceOne": "Dieser Befehl kann nur ein Gerät zur Abfrage auswählen",
      "select_device_list": "Ausgewählte Geräteliste",
      "small_size": "Klein",
      "medium_size": "Mittel",
      "large_size": "Groß",
      "device_info": "Gerätedetails",
      "notification": "Benachrichtigung",
      "notif_title": "Benachrichtigungsinhalt",
      "notif_msg": "Ab dem 5. November 2024 wird das ETV Service Center alle Materialien löschen, die länger als ein Jahr gespeichert wurden. Bitte sichern Sie wichtige Materialien im Voraus. Vielen Dank für Ihr Verständnis und Ihre Kooperation.",
      "reduce": "Verkleinern",
      "bound_material": "Gebundenes Material",
      "tip_material": "Gebundenes Material kann nicht gelöscht werden. Bitte zuerst das Material entbinden",
      "boundpo": "Gebundenes Programm",
      "bind_progron": "Dieses Material ist an ein Programm gebunden und kann nicht gelöscht werden",
      "index": "Index",
      "source": "Quelle",
      "getUploadSet_tip": "Fehler beim Abrufen der Material-Upload-Einstellungen",
      "getUploadstartTime_tip": "Material-Upload ist zur aktuellen Zeit verboten. Bitte außerhalb der verbotenen Zeiten hochladen",
      "getUploadendTim": "Material-Upload verboten",
      "download": "Herunterladen",
      "network_import": "Netzwerkimport",
      "mobile_mode": "Mobilmodus",
      "standalone_mode": "Einzelmodus",
      "network_connection": "1. Netzwerkverbindung",
      "network_methods": "Es gibt zwei Arten von Netzwerkverbindungen:",
      "network_method_1": "(1) Einstellungen → Netzwerk und Internet → WLAN → Netzwerk verbinden → Nach der Netzwerkverbindung ETV öffnen → Netzwerksymbol wird weiß, Netzwerkverbindung erfolgreich.",
      "network_method_2": "(2) ETV öffnen → Rechtsklick → Softwareeinstellungen → Netzwerkimport auswählen, Weiter klicken → Eigenschafteneinstellungen → WLAN-Einstellungen → Zum WLAN-Verbindungsbildschirm wechseln, Netzwerk verbinden → Zurück zum vorherigen Bildschirm → Zurück zur ETV-Hauptseite → Netzwerksymbol wird weiß, Netzwerkverbindung erfolgreich.",
      "account_registration": "2. Konto Registrierung",
      "registration_methods": "Es gibt zwei Registrierungsarten:",
      "registration_method_1": "(1) Konto vom Vorgesetzten zugewiesen: Vorgesetzter meldet sich an → Kundenverwaltung → Kunde hinzufügen → Kundendaten ausfüllen und bestätigen → Erfolgreich erstellt, Konto wird in der Kundenliste angezeigt.",
      "registration_method_2": "(2) Freie Registrierung: Anmeldeseite des Servers → Konto registrieren → Daten ausfüllen und absenden → Erfolgreich registriert.",
      "invitation_code_source": "Einladungscode-Quelle: Vorgesetzter meldet sich an → Systemeinstellungen → Einladungscode-Verwaltung → Einladungscode hinzufügen.",
      "device_connection": "3. Geräteverbindung",
      "device_connection_steps": "ETV öffnen → Rechtsklick → Softwareeinstellungen → Netzwerkimport auswählen, Weiter klicken → Serveradresse (Adresse des Servers), Kontrollport (Standard 8899), Benutzername (zugewiesenes oder registriertes Konto) eingeben → Verbinden klicken → Erfolgreich verbunden, Gerät wird im Backend angezeigt.",
      "connect_terminal": "1. Terminalgerät verbinden",
      "scan_qr_code": "1. QR-Code oben links scannen: Terminal-QR-Code scannen, um Gerät zu verbinden.",
      "device_List": "2. Geräteliste oben rechts: Liste zeigt alle Geräte im lokalen Netzwerk, Geräte auswählen.",
      "remote_Command": "2. Fernbefehl",
      "send_Command": "Befehl an Terminalgerät senden, Gerät führt entsprechende Aktionen aus",
      "quick_send_program": "3. Programm schnell senden",
      "quick_send_steps": "Schnellbefehl zur Anzeige senden → Lokale Bilder, Videos, Dokumente auswählen, Material auswählen und bestätigen → Programmwiedergabezeit einstellen und bestätigen → Programm erfolgreich gesendet.",
      "program_creation": "4. Programmerstellung",
      "new_program": "1. Neues Programm erstellen: Mindestens zwei Zeichen für den Programmnamen eingeben (Name wird automatisch nach Erstellungszeit generiert), Bildschirmrichtung und Anzeigetyp auswählen, nach erfolgreicher Erstellung zur Programmbearbeitungsseite wechseln.",
      "program_editing": "2. Programmbearbeitung: Programmwiedergabemodus auswählen (Ersetzen, Einfügen, Hinzufügen), auf „<img src='/static/images/help/icon.png' alt='' />“ klicken, um Steuerelemente (Bild, Video, Mischwiedergabe, Dokumente usw.) hinzuzufügen, Größe und Position der Steuerelemente anpassen, auf „<img src='/static/images/help/icon_2.png' alt='' />“ klicken, um Material hinzuzufügen, unten verschiedene Eigenschaften des Steuerelements einstellen.",
      "program_sending": "5. Programm senden",
      "send_program_steps": "Programm erstellen → Senden klicken → Geräteliste wird angezeigt, Geräte auswählen → Bestätigen klicken → Zum Download-Fortschrittsbildschirm wechseln, Fortschritt anzeigen → Bei 100% wird „Fertig“ angezeigt → Gerät spielt gesendetes Programm ab.",
      "simple_mode_title": "1. Einfache Modus (Standard)",
      "simple_mode_description": "Dieser Modus ist der Standardimportmodus für Einzelgeräte. Bilder und Videos einfach im Hauptverzeichnis des USB-Sticks speichern und USB-Stick in das Hauptgerät einstecken, um den Import abzuschließen.",
      "simple_mode_note": "(Hinweis: Unterstützt nur den Import von Bildern und Videos, für andere Szenarien bitte den zweiten Einzelmodus verwenden)",
      "regular_mode_title": "2. Regulärer Modus",
      "regular_mode_description": "Einzelmodus auswählen und Weiter klicken, Einzelmodus-Bildschirm wird angezeigt (siehe unten)",
      "regular_mode_steps": "1. Hauptbildschirm-Layouteinstellungen aufrufen<br>2. Nebenbildschirm-Layouteinstellungen aufrufen",
      "step_one": "Schritt 1:",
      "step_one_description": "USB-Stick einstecken, im Hauptverzeichnis einen Ordner „etv-media“ erstellen, im etv-media-Ordner einen „main“-Ordner erstellen, für Dual-Screen-Aufgaben im etv-media-Ordner einen „double“-Ordner erstellen",
      "step_two": "Schritt 2:",
      "step_two_description": "Entsprechend der Haupt- oder Nebenbildschirm-Layouteinstellungen im main- oder double-Ordner Ordner 1/2/3/4 erstellen",
      "step_three": "Schritt 3:",
      "step_three_description": "Bilder/Videos in die entsprechenden Ordner 1/2/3/4 im main- oder double-Ordner kopieren",
      "step_four": "Schritt 4:",
      "step_four_description": "Unterstützt die Vollbildanzeige von PDF-Dokumenten, nur ein Dokument erlaubt",
      "step_five": "Schritt 5:",
      "step_five_description": "Audio-Dateien im MAIN/DOUBLE-Verzeichnis ablegen, das System wechselt automatisch zwischen den Dateien",
      "play_order_title": "Wiedergabereihenfolge:",
      "play_order_description": "1: Dateien mit Zahlen werden zuerst abgespielt, in aufsteigender Reihenfolge<br>2: Dateien mit Buchstaben werden danach abgespielt, in alphabetischer Reihenfolge<br>3: Dateien mit chinesischen Schriftzeichen werden zuletzt abgespielt, in alphabetischer Reihenfolge des ersten Zeichens",
      "document_playback_note": "Dokumentenwiedergabe (Standardmäßig aktiviert): Auf 3128- und M11-Motherboards ist die Dokumentenanzeige standardmäßig deaktiviert (zur Leistungsoptimierung), muss manuell aktiviert werden",
      program_review: 'Programmüberprüfung',
      pass: 'Bestehen',
      not_passed_or_not_reviewed: 'Nicht bestanden oder nicht überprüft',
      play_mode: 'Wiedergabemodus',
      review_status: 'Überprüfungsstatus',
      reject: 'Ablehnen',
      review_content: 'Überprüfungsinhalt',
      enter_review_content: 'Bitte geben Sie den Überprüfungsinhalt ein',
      device_quantity: "Geräteanzahl",
      noMore: 'Keine weiteren',
      nameLengthLimit: 'Bitte die Namenslänge auf 50 Zeichen beschränken',
      "customer_title": "Kontoabfrage",
      "authorized_devices": "Autorisierte Geräteanzahl",
      "enable": "Aktivieren",
      "disable": "Deaktivieren",
      "expired": "Konto abgelaufen",
      "valid_date": "Gültigkeitsdatum",
      "valid_date_placeholder": "Gültigkeitsdatum eingeben",
      "capacity_rule": "Serverkapazität muss ein Vielfaches von 100 sein",
      "capacity_label": "Serverkapazität (MB)",
      "download_speed": "Download-Geschwindigkeitslimit",
      "submit_btn": "Einreichen",
      "sub_accounts":"Nur Unterkonten können bearbeitet werden",
      plan_mode: 'Planmodus',
      default_mode: 'Standardmodus',
      "help": "Hilfe",
      "network_mode": "Netzwerkverteilung",
      "phone_mode": "Telefonmodus",
      "apk_download": "APK herunterladen",
      "android": "Android",
      "ios": "iOS",
      "app_name": "ETV-H5 Informationsveröffentlichungs-Assistent",
      "info_publish": "Informationsveröffentlichung",
      "upload_material": "Materialien hochladen",
      "wx_config_incomplete": "WeChat-Konfigurationsparameter unvollständig",
      "wx_missing_appid": "appId in WeChat-Konfiguration fehlt",
      "wx_jssdk_not_loaded": "WeChat JS-SDK nicht geladen, bitte Seite aktualisieren und erneut versuchen",
      "wx_version_not_support_scan": "Aktuelle WeChat-Version unterstützt Scan-Funktion nicht, bitte WeChat aktualisieren",
      "wx_signature_failed": "WeChat-Signaturüberprüfung fehlgeschlagen, bitte Backend-Signaturalgorithmus und URL prüfen",
      "wx_domain_not_config": "Aktuelle Domain nicht in WeChat Official Platform konfiguriert, bitte JS-Interface-Sicherheitsdomain konfigurieren",
      "wx_config_failed": "WeChat-Konfiguration fehlgeschlagen",
      "wx_scan_init_failed": "Initialisierung der WeChat-Scan-Funktion fehlgeschlagen",
      "browser_not_support_camera": "Ihr Browser unterstützt keine Kamerafunktion",
      "scan_content_unrecognized": "Scan-Inhalt nicht erkannt, bitte erneut versuchen!",
      "scan_lib_load_failed": "Scan-Bibliothek konnte nicht geladen werden, bitte Seite aktualisieren",
      "wx_scan_not_ready": "WeChat-Scan-Funktion nicht bereit, initialisiere...",
      "wx_scan_permission_denied": "WeChat-Scan-Berechtigung verweigert, bitte WeChat-Einstellungen prüfen oder Seite aktualisieren",
      "scan_connect": "Scan zum Verbinden",
      "confirm_connect_device": "Geräteverbindung bestätigen",
      "confirm_connect_device_msg": "Mit {deviceName} verbinden?",
      "data_lost_rescan": "Daten verloren, bitte erneut scannen",
      "connect_failed_retry": "Verbindung fehlgeschlagen, bitte erneut versuchen",
      "qrcode_placeholder": "Bitte platzieren Sie den QR-Code im Rahmen",
      "camera_unauthorized": "Kamerazugriff nicht autorisiert",
      "camera_not_found": "Kameragerät nicht gefunden",
      "camera_select_failed": "Kameragerät konnte nicht ausgewählt werden",
      "camera_start_failed": "Kamera konnte nicht gestartet werden, bitte klicken Sie zum erneuten Versuch",
      "camera_permission_requesting": "Kameraberechtigung wird angefragt",
      "camera_click_to_start": "Zum Starten der Kamera auf den Bildschirm klicken",
      "camera_permission_denied": "Bitte erlauben Sie den Kamerazugriff und klicken Sie zur Wiederholung",
      "camera_device_not_found": "Kameragerät nicht gefunden",
      "camera_init_failed": "Kamera-Initialisierung fehlgeschlagen, bitte klicken Sie zum erneuten Versuch",
      "scanner_not_initialized": "QR-Code-Scanner nicht initialisiert",
      "scan_start_failed": "QR-Code-Scan konnte nicht gestartet werden",
      "qrcode_format_error": "Ungültiges QR-Code-Datenformat",
      "qrcode_verify_success": "QR-Code-Validierung erfolgreich",
      "qrcode_verify_failed": "QR-Code-Validierung fehlgeschlagen",
      "process_failed": "Verarbeitung fehlgeschlagen",
      "camera_not_found_current": "Aktuelle Kamera nicht gefunden",
      "camera_switch_failed": "Wechsel zu anderer Kamera fehlgeschlagen",
      "camera_no_alternatives": "Keine alternativen Kameras gefunden",
      "scan_QR_code": "Scannen",
      "img_size": "Bildpixel-Anomalie, bitte überprüfen und hochladen.",
      "file_size_exceed_skip":'Die Dateigröße darf nicht überschreiten',
      "processing": "Wird verarbeitet",
      "failed": "Fehlgeschlagen",
  }
}